'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IsDevelop = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(IsDevelop, _Component);

  function IsDevelop() {
    (0, _classCallCheck3.default)(this, IsDevelop);
    return (0, _possibleConstructorReturn3.default)(this, (IsDevelop.__proto__ || (0, _getPrototypeOf2.default)(IsDevelop)).apply(this, arguments));
  }

  (0, _createClass3.default)(IsDevelop, [{
    key: 'render',
    value: function render() {
      var styles = require('./IsDevelop.scss');
      var availableOnMobile = this.props.availableOnMobile;

      console.log('availableOnMobile', availableOnMobile);
      return _react2.default.createElement(
        'div',
        { className: styles.boxDev },
        availableOnMobile ? _react2.default.createElement(
          'div',
          { className: styles.availableBox },
          _react2.default.createElement(
            'span',
            null,
            'T\xEDnh n\u0103ng ch\u1EC9 ph\xE1t h\xE0nh tr\xEAn mobile. ',
            _react2.default.createElement('br', null),
            'Vui l\xF2ng s\u1EED d\u1EE5ng mobile ho\u1EB7c t\u1EA3i app \u0111\u1EC3 s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5.'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.downApp },
            _react2.default.createElement(
              'a',
              {
                target: '_blank',
                href: 'https://apps.apple.com/vn/app/lookme-%C4%91%E1%BA%B7t-l%E1%BB%8Bch-l%C3%A0m-%C4%91%E1%BA%B9p/id1447215019'
              },
              _react2.default.createElement('i', { className: 'fa fa-apple fa-3x xbtKsXjNmKL3ypvVns-ry' })
            ),
            _react2.default.createElement(
              'a',
              {
                target: '_blank',
                href: 'https://play.google.com/store/apps/details?id=com.lookme.client&hl=en'
              },
              _react2.default.createElement('i', { className: 'fa fa-android fa-3x _3s04Ao4xplWCsa7vTeEZFg' })
            )
          )
        ) : 'Tính năng đang phát triển.'
      );
    }
  }]);
  return IsDevelop;
}(_react.Component), _class.propTypes = {
  route: _react.PropTypes.object,
  availableOnMobile: _react.PropTypes.bool
}, _temp);
exports.default = IsDevelop;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/IsDevelop.js
// module id = 725
// module chunks = 0